var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPin = function SvgPin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "17 11 21 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1622 11C20.777 11 15 15.9092 15 23.5016C15 28.3498 18.7247 34.0517 26.1588 40.6227C26.7365 41.1258 27.603 41.1258 28.1807 40.6227C35.5997 34.0517 39.3243 28.3498 39.3243 23.5016C39.3243 15.9092 33.5473 11 27.1622 11ZM27.1622 26.2458C25.4899 26.2458 24.1216 24.8737 24.1216 23.1967C24.1216 21.5196 25.4899 20.1475 27.1622 20.1475C28.8345 20.1475 30.2027 21.5196 30.2027 23.1967C30.2027 24.8737 28.8345 26.2458 27.1622 26.2458Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pin.4add8a5d0054778d4be77da4a79e4aaf.svg";